export default {"src":"/_next/static/media/truck.9fe414f0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};